import React, { useMemo } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { useDemo } from '../../contexts/DemoContext';
import { ScreenContainer } from '../story/ScreenContainer';
import { ScreenHeading } from '../story/ScreenHeading';
import { DialogueList } from '../story/DialogueList';
import { ActionRow } from '../story/ActionRow';
import { Button } from '../story/Button';
import { RippleMap } from '../RippleMap';
import { SceneIllustration } from '../art/SceneIllustration';
import { SavannaScene } from '../art/SavannaScene';
import { getRippleCards } from '../../utils/worldState';
import { AMARA_MENTOR } from '../../data/speakers';
const SCENE_TEXT = 'Amara’s hand rests near an acacia root. Two separate lines leave the scene: one labeled grass sound, from the grass by the old pipe, and one labeled group sound, from the Meerkat wall.';
export function RippleScreen() {
  const {
    state,
    dispatch,
    world
  } = useDemo();
  const cards = useMemo(() => getRippleCards(state.actionEffects, state.witnessEffects), [state.actionEffects, state.witnessEffects]);
  return <ScreenContainer data-id="element-260" data-mp="1m0j4xw2e5dbj">
      <ScreenHeading eyebrow="Ripple Map" data-id="element-261" data-mp="1m0svplv9foia">Conditions, not scores.</ScreenHeading>
      <p className="mt-3 max-w-prose" data-id="element-262" data-mp="189ebjbpm9h9n">This map shows what changed on your route. Nothing here is a grade.</p>
      <div className="mt-8" data-id="element-263" data-mp="1ca7zg5326w2j">
        <RippleMap cards={cards} data-id="element-264" data-mp="1cbj384wi83tn" />
      </div>

      <div className="mt-12 grid gap-8 lg:grid-cols-[1.35fr_1fr] lg:items-center" data-id="element-265" data-mp="200apygrbrtz1">
        <SceneIllustration description={SCENE_TEXT} quietTitle="Two sounds" data-id="element-266" data-mp="1zy7n2w52q6cw">
          <SavannaScene world={world} label={SCENE_TEXT} soundLines data-id="element-267" data-mp="24yvfnm8yav98" />
        </SceneIllustration>
        <DialogueList lines={[{
        kind: 'speech',
        speaker: AMARA_MENTOR,
        text: 'I can be scared and still look again.'
      }, {
        kind: 'sound',
        text: 'Water moving through one clear channel.'
      }]} data-id="element-268" data-mp="1qz455vhn7wzz" />
      </div>

      <ActionRow onBack={() => dispatch({
      type: 'BACK'
    })} data-id="element-269" data-mp="kk381mgvt8rt">
        <Button onClick={() => dispatch({
        type: 'GO',
        screen: 'signalCheck'
      })} iconAfter={<ArrowRightIcon size={18} aria-hidden="true" data-id="element-271" data-mp="2matv1uu8nfm8" />} data-id="element-270" data-mp="khh21r9n31bp">
          Open the Signal Check
        </Button>
      </ActionRow>
    </ScreenContainer>;
}